import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class BlogService extends BaseService{

  apiUrl = "Blog.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getBlogPosts(country: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getBlogpostsForStartpage"),
      new UrlParam("country", country)
    );
    return this.get(url);
  }

}
